/* assets/section-specification-with-tab.js */
(() => {
  'use strict';

  const SECTION_SEL = '.specs-split';
  const ITEM_SEL = '[data-specs-split-item]';
  const TOGGLE_SEL = '[data-specs-split-toggle]';
  const CONTENT_SEL = '[data-specs-split-content]';

  function setOpen(item, open) {
    const content = item.querySelector(CONTENT_SEL);
    const toggle = item.querySelector(TOGGLE_SEL);
    if (!content || !toggle) return;

    item.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      content.style.height = `${content.scrollHeight}px`;
      content.addEventListener(
        'transitionend',
        (event) => {
          if (event.propertyName !== 'height') return;
          if (item.classList.contains('is-open')) {
            content.style.height = 'auto';
          }
        },
        { once: true }
      );
    } else {
      if (content.style.height === 'auto' || content.style.height === '') {
        content.style.height = `${content.scrollHeight}px`;
        content.offsetHeight;
      }
      content.style.height = '0px';
    }
  }

  function applyDefaultState(root) {
    root.querySelectorAll(ITEM_SEL).forEach((item) => {
      const shouldOpen = item.getAttribute('data-default-open') === 'true';
      const content = item.querySelector(CONTENT_SEL);
      const toggle = item.querySelector(TOGGLE_SEL);
      if (!content || !toggle) return;

      item.classList.toggle('is-open', shouldOpen);
      toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      content.style.height = shouldOpen ? 'auto' : '0px';
    });
  }

  function onToggleClick(event, root) {
    const toggle = event.target.closest(TOGGLE_SEL);
    if (!toggle || !root.contains(toggle)) return;

    event.preventDefault();
    const item = toggle.closest(ITEM_SEL);
    if (!item) return;

    setOpen(item, !item.classList.contains('is-open'));
  }

  function init(root) {
    if (!root || root.dataset.specsSplitReady === 'true') return;
    root.dataset.specsSplitReady = 'true';

    root._specsSplitOnClick = (event) => onToggleClick(event, root);
    root.addEventListener('click', root._specsSplitOnClick);

    applyDefaultState(root);
  }

  function destroy(root) {
    if (!root) return;

    if (root._specsSplitOnClick) {
      root.removeEventListener('click', root._specsSplitOnClick);
      delete root._specsSplitOnClick;
    }

    delete root.dataset.specsSplitReady;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SECTION_SEL).forEach(init);
  }

  function destroyAll(scope) {
    (scope || document).querySelectorAll(SECTION_SEL).forEach(destroy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyAll(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest(SECTION_SEL);
    if (!root) return;
    const item = event.target.closest(ITEM_SEL);
    if (!item) return;
    setOpen(item, true);
  });
})();
